module.exports = __webpack_public_path__ + "img/RoyalTower.45a2504f.png";